import React from "react"
export const CrossDockingDetailContext = React.createContext(null);

export const useCrossDockingDetailContext = () => {

    const context = React.useContext(CrossDockingDetailContext);

if (!context) throw new Error("Cross-Docking Detail Context not provided!");

return context;
}